import { useMemo } from "react";

import { useDataLayerQuery } from "#/hooks/useDataLayer";
import { BreedingValuesBreedService } from "#/pages/breeding-values/BreedingValuesBreedService";

/**
 * Custom hook for Breeding Values Breed Query.
 * Uses the BreedingValuesComparisonRankService to perform POST queries.
 *
 * @returns {object} The data layer query object (result, isLoading, error, query, reload).
 */
export function useBreedingValuesBreedQuery() {
  const service = useMemo(() => new BreedingValuesBreedService(), []);

  return useDataLayerQuery({
    ident: "breeding-values-pasma",
    dataLayer: service,
  });
}
